import React from 'react';
import {message as antdMessage} from 'antd';
import { EmptyIcon, FailedIcon } from './Icons';
import { GlobalSettingsContextProvider } from 'contexts/GlobalSettingsContext';
import _ from 'lodash';

/**
 * WCAG 2.1 AA — Status messages (4.1.3):
 *  - Error / Warning messages use role="alert" (assertive — read immediately)
 *  - Success / Info messages use role="status" (polite — read at next opportunity)
 */
const antdMessageContent = ({type, heading = '', content, duration = 10, icon, key: _key, role: ariaRole}) => {
    const key = _key || Math.random();
    if(heading){
        heading = <><strong>{heading}</strong> <br/></>
    }
    let _content = (
        <span role={ariaRole}>
            {heading} {content} <button type="button" className="message-close" aria-label="Dismiss notification" onClick={() => antdMessage.destroy(key)}>x</button>
        </span>
    );
    if(!_.isString(content)){
        // add providers only if the message is not a string
        _content = (
            <GlobalSettingsContextProvider allowApiFetch={false}>
                {_content}
            </GlobalSettingsContextProvider>
        )
    }
    return(
        antdMessage[type]({
            key,
            content: _content,
            duration,
            icon
        })
    )
}

const message = {
    success(content, duration) {
        return antdMessageContent({type: 'success', heading: 'Success!', content, duration, role: 'status'})
    },
    error(content, duration, key){
        return antdMessageContent({type: 'error', heading: 'Failed!', content, duration, icon: <FailedIcon />, key, role: 'alert'});
    },
    warn(content, duration){
        return antdMessageContent({type: 'warning', content, duration, icon: <EmptyIcon />, role: 'alert'});
    },
    info(content, duration){
        return antdMessageContent({type: 'info', content, duration, role: 'status'});
    },
    loading(content, duration){
        return antdMessageContent({type: 'loading', content, duration, role: 'status'});
    },
    open(content, duration){
        return antdMessageContent({type: 'open', content, duration, role: 'status'});
    },
}

export default message;